import { render, staticRenderFns } from "./Records_printing.vue?vue&type=template&id=100bdfb2&scoped=true"
import script from "./Records_printing.vue?vue&type=script&lang=js"
export * from "./Records_printing.vue?vue&type=script&lang=js"
import "./Records_printing.vue?vue&type=style&index=0&id=100bdfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100bdfb2",
  null
  
)

export default component.exports